import model from "./model";
import image from "./image";
import camera from "./camera";

import { getField, updateField } from "vuex-map-fields";
import DetectionService from "@/services/detection.service"

import Constants from "@/constants/Constants";
const goodImageClass = Constants.GOOD_IMAGE_CLASS;

const SET_STATE = "SET_STATE";
const SET_OK = "SET_OK";
const SET_IMAGE_URI = "SET_IMAGE_URI";
const SHOW_IMAGE_PREVIEW_MODAL = "SHOW_IMAGE_PREVIEW_MODAL";
const HIDE_IMAGE_PREVIEW_MODAL = "HIDE_IMAGE_PREVIEW_MODAL";
const SET_AUTO_SLIDE = "SET_AUTO_SLIDE";

export default {
  namespaced: true,
  state: {
    info: null,
    state: false,
    ok: true,

    imageURI: '',
    isVisible: false,
    selectedImage: {},
    imagePreviewVisible: false,

    showCamera: true,
    showCameraImageBorder: true,

    // Preview image before detection by selecting image 
    isPreviewImageDetection: false,
    autoSlide: false,
  },
  actions: {
    async loadModel({ commit }, payload) {
      let response = await DetectionService.unloadModel({
        user: payload.username,
      });

      if (response.status != 200) return;

      response = await DetectionService.loadModel({
        user: payload.username,
        model_name: payload.model,
        threshold: payload.threshold,
      });

      if (response.status != 200) return;

      commit(SET_STATE, true);
    },

    async unloadModel({ commit }, payload) {
      await DetectionService.unloadModel({
        user: payload.username,
      });

      commit(SET_STATE, false);
    },

    async runDetection({ commit, state, dispatch }, payload) {
      let detectResponse = await DetectionService.detect({
        user: payload.username,
        image_name: payload.fileName,
        image_key : payload?.image_key
      });

      let cdnCloudFormation = Constants.CDN_CLOUD_FORMATION.runDetection;
      let s3BucketUrl = process.env.VUE_APP_S3_BUCKET_URL;

      let cdnImage = detectResponse.data.s3_object_url.replace(s3BucketUrl, cdnCloudFormation);

      commit(SET_IMAGE_URI, cdnImage);

      if (detectResponse.status != 200) return;

			// dispatch('image/addPreviewResult');

      commit(SET_OK, detectResponse.data.class === goodImageClass);
      
      if (state.ok === false) {
        let ngSound = new Audio(require('@/constants/sounds/NG.mp3'));
        ngSound.play();
      } else {
        let okSound = new Audio(require('@/constants/sounds/OK.mp3'));
        okSound.play();
      }
    },

    showFormModal({ commit }) {
			commit('showModal');
		},
		hideFormModal({ commit }) {
			commit('hideModal');
    },
    
    showImagePreviewModal({ commit }) {
      commit("SHOW_IMAGE_PREVIEW_MODAL");
    },
    hideImagePreviewModal({ commit }) {
      commit("HIDE_IMAGE_PREVIEW_MODAL");
    },

    switchAutoSlide({ commit, state }) {
      commit(SET_AUTO_SLIDE, !state.autoSlide);
    }
  },
  mutations: {
    updateField,

    SET_STATE(state, payload) {
      state.state = payload;
    },

    SET_OK(state, payload) {
        state.ok = payload;
    },

    SET_IMAGE_URI(state, payload) {
        state.imageURI = payload;
    },
    SET_SELECTED_IMAGE(state, payload) {
        state.selectedImage = payload;
    },

    showModal(state) {
			state.isVisible = true;
		},
		hideModal(state) {
			state.isVisible = false;
    },
    
    SHOW_IMAGE_PREVIEW_MODAL(state) {
      state.imagePreviewVisible = true;
    },
    HIDE_IMAGE_PREVIEW_MODAL(state) {
      state.imagePreviewVisible = false;
    },

    SET_SHOW_CAMERA(state, payload) {
      state.showCamera = payload;
    },
    SET_PREVIEW_IMAGE_DETECTION(state, payload) {
      state.isPreviewImageDetection = payload;
    },
    SET_SHOW_CAMERA_IMG_BORDER(state, payload) {
      // console.log('SET_SHOW_CAMERA_IMG_BORDER', payload);
      state.showCameraImageBorder = payload;
    },

    SET_AUTO_SLIDE(state, payload) {
      state.autoSlide = payload;
    }

  },
  getters: {
    getField,
  },
  modules: {
    model,
    image,
    camera
  },
};
